import { Store } from 'vuex';

const defaults = {
	globalHomeName: "GlobalHome",
	moduleNamespace: "global-workspace"
};

interface GlobalWorkspaceOptions {

	// name of route to push when global is activated
	globalHomeName: string;

	// namespace the store module is registered under
	moduleNamespace: string;

	// Vuex Store instance
	store: Store<unknown>;
}

export { defaults, GlobalWorkspaceOptions };
